import React from "react";
import { cn } from "@/lib/utils";

export type PillKind =
  | "open" | "hold" | "closed" | "filled" | "capped"
  | "prio-high" | "prio-med" | "prio-low"
  | "med-none" | "med-active" | "med-done"
  | "health-ok" | "health-error" | "health-unconfigured";

// Every kind maps onto one of the four fixed status pairs from the design:
// ok (green), warn (amber), alert (red) and neutral.
const OK      = "bg-status-ok-bg text-status-ok-fg";
const WARN    = "bg-status-warn-bg text-status-warn-fg";
const ALERT   = "bg-status-alert-bg text-status-alert-fg";
const NEUTRAL = "bg-status-neutral-bg text-status-neutral-fg";

const PILL_CLASSES: Record<PillKind, string> = {
  "open":       OK,
  "hold":       WARN,
  "closed":     ALERT,
  "filled":     OK,
  "capped":     WARN,
  "prio-high":  ALERT,
  "prio-med":   WARN,
  "prio-low":   OK,
  "med-none":   NEUTRAL,
  "med-active": WARN,
  "med-done":   OK,
  "health-ok":          OK,
  "health-error":       ALERT,
  "health-unconfigured": NEUTRAL,
};

export function pillColorClasses(kind: PillKind): string {
  return PILL_CLASSES[kind] ?? NEUTRAL;
}

export function Pill({ kind, children, className }: { kind: PillKind; children: React.ReactNode; className?: string }) {
  return (
    <span className={cn(
      "inline-flex items-center rounded-pill px-3 py-1 text-[13px] font-bold leading-none whitespace-nowrap",
      pillColorClasses(kind),
      className
    )}>
      {children}
    </span>
  );
}
